module.exports = __webpack_public_path__ + "static/media/logo_oceanbank.fab5569e.svg";